import HTML from './bid-response.html';
import get from 'lodash/get';
import saveResponseService from './save-response.service'

const
  // states
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  ERROR = 'ERROR';

export { HTML, BidResponsePreloadController as Controller }

BidResponsePreloadController.$inject = ['NotificationUtils', 'RfpHotelBidRepository', '$state', 'MainAPI'];
function BidResponsePreloadController(utils, rfpHotelBidRepository, $state, mainAPI) {
  const
    vm = this;

  vm.isLoading = () => vm.state === LOADING;
  vm.isLoaded = () => vm.state === LOADED;

  $onInit();

  function $onInit() {
    vm.state = LOADING;

    rfpHotelBidRepository.getBidResponseDraft($state.params.bidId)
      .then(httpResponse => {
        const bid = httpResponse.data;
        vm.options = getOptions(bid);
        vm.bid = bid;
        vm.state = LOADED;
      })
      .catch(e => {
        vm.error = e;
        vm.state = ERROR;
      });
  }

  function getOptions(bid) {
    return {
      header: {
        pretitle: get(bid, 'specifications.name', ''),
        title: 'Respond to RFP',
        subtitle: get(bid, 'supplierCompany.name', ''),
      },
      buttons: {
        cancel: {
          label: 'Cancel',
          action: saveResponseService.toBidManager
        },

        draft: {
          label: 'Save as Draft',
          action: answers => saveResponseService.saveDraftResponse(
            () => utils.onSave(() => mainAPI.saveDraftResponse(bid.id, answers))
          )
        },

        submit: {
          label: 'Send Response',
          action: response => saveResponseService.saveResponse(response, r => {
            const ignoreErrors = true;
            return utils.onSave(() => mainAPI.setBidResponse(bid.id, r.answers, ignoreErrors));
          })
        },
      }
    };
  }
}
